import { palette } from "@dev/ee-components";
import styled from "styled-components";

export const SocialPreviewWrapper = styled.div<{ isEdit?: boolean } >`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    min-height: ${(props) => (props.isEdit ? '380px' : '330px')};
    background-color: ${palette.gray[1]};
    border: ${(props) => (props.isEdit ? `solid 1px ${palette.gray[3]}` : 'none')};
    border-radius: 8px;
    padding: ${(props) => (props.isEdit ? '24px' : '0')};
`;

export const ImagePreviewWrapper = styled.div`
    width: 100%;
    max-width: 445px;
    height: 224px;
    border: solid 1px ${palette.gray[3]};
    border-radius: 4px 4px 0 0;
    overflow: hidden;

    img {
        display: block;
        object-fit: cover;
        width: 100%;
        height: 224px;
    }
`;

export const EmptyImageState = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    max-width: 445px;
    height: 224px;
    background-color: ${palette.basic.paper};
    border: solid 1px ${palette.gray[3]};
    border-radius: 4px 4px 0 0;
`;

export const PageDataWrapper = styled.div`
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    width: 100%;
    max-width: 445px;
    background-color: ${palette.basic.paper};
    border: solid 1px ${palette.gray[3]};
    border-top: none;
    border-radius: 0 0 4px 4px;
    padding: 8px;
    text-overflow: ellipsis;
`;

export const PageDataText = styled.div`
    font-family: Nunito;
    font-size: 16px;
    line-height: 24px;
    font-weight: 400;
    color: ${palette.gray[7]};
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`;
